import { createContext, useContext } from 'react'

interface MobileSidebarContextValue {
  isMobile: boolean
  closeMobileSidebar: () => void
  openMobileSidebar: () => void
}

const defaultValue: MobileSidebarContextValue = {
  isMobile: false,
  closeMobileSidebar: () => {},
  openMobileSidebar: () => {},
}

export const MobileSidebarContext =
  createContext<MobileSidebarContextValue>(defaultValue)

export function useMobileSidebar() {
  return useContext(MobileSidebarContext)
}
